module.exports = __webpack_public_path__ + "img/appleStoreBg.6dab5dc3.png";